import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { MediaType } from '../media-constant';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const IELTSScoreConverterNodeEditable = dynamicEditorComponent<any>(() =>
  import(/* webpackExports: "IELTSScoreConverterNodeEditable" */'./IELTSScoreConverterNode').then((mod) => mod.IELTSScoreConverterNodeEditable)
);

export const renderIELTSScoreConverter =
  (props: RenderElementProps) => {
    const { children, element } = props;
    if (element.type === MediaType.CONVERTER) {
      return (
        <div contentEditable={false}>
          {children}
          <IELTSScoreConverterNodeEditable id={element.id as string} isPreview={false} />
        </div>
      );
    }
    return null;
  };
